// The Proposed Steps warning banners for a replacement whose customer asked
// for a different ship-to address or expedited shipping (2026-10-02;
// server/src/ai/replacement-shipping-request.js, stored on the suggestion as
// modelMeta.replacementShippingRequest). Pure, so node --test can cover it.

// Which banners to show: only when the suggestion has a process_replacement
// step and the customer actually asked. Shown on decided suggestions too —
// it explains why the replacement's address differs from the order's.
export function replacementShippingBanners(suggestion) {
  const req = suggestion?.modelMeta?.replacementShippingRequest
  const hasReplacementStep = (suggestion?.proposedActions ?? []).some((a) => a?.type === 'process_replacement')
  if (!req || !hasReplacementStep) return []
  const banners = []
  if (req.addressRequested) {
    banners.push({
      kind: 'address',
      lines: addressLines(req.address),
      quote: req.addressQuote ?? null,
      international: req.addressNotPrefilledReason === 'international',
      prefilled: req.addressPrefilled === true,
    })
  }
  if (req.expeditedRequested) banners.push({ kind: 'expedited', quote: req.expeditedQuote ?? null })
  return banners
}

// The address the customer gave, one line per part, only what they gave.
export function addressLines(address) {
  if (!address) return []
  const cityLine = [[address.city, address.region].filter(Boolean).join(', '), address.zip].filter(Boolean).join(' ')
  return [address.name, address.address1, address.address2, cityLine, address.country].filter((l) => l && String(l).trim())
}

// The 1A Support mailbox's inbound warnings (2026-10-06): "Multiple order
// references found; using …" and "Multiple customer emails found; using …",
// stored on the suggestion as modelMeta.inboundWarnings
// (server/src/channels/m365/support-order.js). Shown in the same compact
// warning style as the replacement banners, at the top of Proposed Steps,
// whether or not the suggestion has any steps.
export function inboundWarnings(suggestion) {
  const warnings = suggestion?.modelMeta?.inboundWarnings
  return Array.isArray(warnings) ? warnings.filter((w) => typeof w === 'string' && w.trim()) : []
}
